import { render, staticRenderFns } from "./SecondFrame.vue?vue&type=template&id=dd45b4b2&"
import script from "./SecondFrame.vue?vue&type=script&lang=js&"
export * from "./SecondFrame.vue?vue&type=script&lang=js&"
import style0 from "./SecondFrame.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports